import { CameraImageModel } from 'api/models';
import ImageSlider from 'modules/dashboard/components/image-slider/ImageSlider';
import { FC, useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface IFrameImageSliderProps {
    show: boolean;
    onClose: () => void;
    images: CameraImageModel[];
    selectedImage: CameraImageModel;
    onSelectedImageChange: (image: CameraImageModel) => void;
    selectedDate: string;
    onSelectedDateChange: (date: string) => void;
    startDate: string;
    endDate: string;
    isLoading: boolean;
    showDatePicker: boolean;
}

const IFrameImageSlider: FC<IFrameImageSliderProps> = (props) => {
    const {
        show,
        onClose,
        images,
        selectedImage,
        onSelectedImageChange,
        selectedDate,
        onSelectedDateChange,
        startDate,
        endDate,
        isLoading,
        showDatePicker,
    } = props;

    const sliderRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (e: any) => {
            if (!sliderRef.current) return;

            if (sliderRef.current === e.target || sliderRef.current.contains(e.target)) return;

            onClose();
        };

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className={twMerge(
                'absolute z-10 bottom-0 left-0 right-0 translate-y-[200px] transition-transform duration-[350ms]',
                show && 'translate-y-0'
            )}
            onClick={(e) => e.stopPropagation()}
        >
            <ImageSlider
                ref={sliderRef}
                className="bg-background-color/60"
                images={images}
                selectedImage={selectedImage}
                onSelectedImageChange={onSelectedImageChange}
                selectedDate={selectedDate}
                onSelectedDateChange={onSelectedDateChange}
                startDate={startDate}
                endDate={endDate}
                isLoading={isLoading}
                showDatePicker={showDatePicker}
            />
        </div>
    );
};

export default IFrameImageSlider;
